/* Force Slick carousels into RTL mode for the Arabic locale.
   Loaded (deferred) after slick.js and before theme.js, so the patch is in
   place before the theme initializes any sliders on $(document).ready.
   Only initialization calls get rtl:true — method calls like
   .slick('refresh') / .slick('slickGoTo', i) are passed through untouched. */
(function () {
	if (document.documentElement.getAttribute('dir') !== 'rtl') return;
	if (!window.jQuery || !jQuery.fn || !jQuery.fn.slick) return;

	var original = jQuery.fn.slick;
	jQuery.fn.slick = function () {
		var args = Array.prototype.slice.call(arguments);
		var isInit = args.length === 0 || args[0] === undefined || (typeof args[0] === 'object' && args[0] !== null);
		if (isInit) {
			// The product image gallery is an LTR island (dir="ltr" on <product-media>),
			// so keep its sliders non-RTL — correct order, hero first, sizes properly.
			var keepLTR = this && this.is && this.is('.slider-featured, .slider-thumb, .product-featured, #product-slider-featured, #product-slider-thumb');
			args[0] = jQuery.extend({}, args[0] || {}, { rtl: keepLTR ? false : true });
		}
		return original.apply(this, args);
	};
})();
